// extracted by mini-css-extract-plugin
export default {"root":"Bdwv9k7v"};